import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CopyLink from '../common/CopyLink';
import ShareResource from '../ShareResource';
var SharesTable = /*#__PURE__*/function (_Component) {
  function SharesTable(props) {
    var _this;
    _classCallCheck(this, SharesTable);
    _this = _callSuper(this, SharesTable, [props]);
    _this.state = {};
    return _this;
  }
  _inherits(SharesTable, _Component);
  return _createClass(SharesTable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        project = _this$props.project,
        shareOptions = _this$props.shareOptions,
        recipientOptions = _this$props.recipientOptions,
        triggerType = _this$props.triggerType;
      return /*#__PURE__*/React.createElement("div", {
        className: "project-proposals-container shares-container box-shadow-1 style-guide"
      }, project.shares.length === 0 ? /*#__PURE__*/React.createElement("div", {
        className: "shares-empty-header"
      }, "There are no shares for this project.") : /*#__PURE__*/React.createElement("table", {
        className: "shares-table table"
      }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Source"), /*#__PURE__*/React.createElement("th", null, "Views"), /*#__PURE__*/React.createElement("th", null, "Action")), project.shares.map(function (shareObject) {
        return /*#__PURE__*/React.createElement("tr", {
          key: shareObject.id || shareObject.url
        }, /*#__PURE__*/React.createElement("td", null, shareObject.candidate_source), /*#__PURE__*/React.createElement("td", null, shareObject.views), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(CopyLink, {
          url: shareObject.url,
          shortForm: true,
          linkText: shareObject.copy_link_text
        })));
      }))), /*#__PURE__*/React.createElement(ShareResource, {
        generateUrl: "/projects/".concat(project.resource_id, "/generate_shareable_link"),
        csrfToken: csrfToken,
        resourceId: project.resource_id,
        triggerType: triggerType,
        triggerText: "Share Project",
        idKey: "share-project-modal",
        resourceType: "Project",
        buttonStyles: "primary",
        sourceOptions: shareOptions,
        recipientOptions: recipientOptions,
        className: "primary btn btn-primary full-width share-project-button",
        id: "share-project"
      }));
    }
  }]);
}(Component);
SharesTable.propTypes = {
  project: PropTypes.shape({}).isRequired,
  csrfToken: PropTypes.string.isRequired,
  shareOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  recipientOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  triggerType: PropTypes.string
};
SharesTable.defaultProps = {
  triggerType: 'link'
};
export default SharesTable;